import { Fragment, useState, useContext } from "react";
import { Transition, Dialog } from "@headlessui/react";
import { classNames } from "../../utils/utils";
import { CancelIcon } from "../../utils/iconFactory";
import { CancelButton, TertiaryButton } from "../Elements/CustomButtons";
import { useTheme } from "../../utils/themeUtils";
import { api } from "../../services/POST";
import { StateContext } from "../../services/context";


export function CancelSubscriptionModal({ isVisible, onClose }: { isVisible: boolean; onClose: () => void }){
  const { themeString } = useTheme()
  const { load, showPopup } = useContext(StateContext) 
  const [isActiveCancelButton, setIsActiveCancelButton] = useState(false)
  async function cancelSubscription() {
    try{
      setIsActiveCancelButton(true);
      await api("/delete_payment")
      load()
      showPopup("Sikeresen lemondtad az előfizetésedet!", "success")
      setIsActiveCancelButton(false);
      onClose()
    } catch (err: any) {
      console.log(err)
      showPopup("Nem sikerült lemondani az előfizetésedet.", "fail");
      setIsActiveCancelButton(false);
      onClose()
    }
  }
  return (
    <Transition appear show={isVisible || isActiveCancelButton} as={Fragment}>
      <Dialog as="div" className={classNames("relative z-40", themeString)} onClose={onClose}>
        <Transition.Child
          as={Fragment}
          enter="ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="fixed inset-0 bg-black/25" />
        </Transition.Child>

        <div className="fixed inset-0 overflow-y-auto">
          <div className="flex min-h-full items-center justify-center p-4 text-center">
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 scale-95"
              enterTo="opacity-100 scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 scale-100"
              leaveTo="opacity-0 scale-95"
            >
              <Dialog.Panel className="relative h-[360px] w-[560px] rounded-[22px] bg-backgroundWhite py-8 text-left align-middle transform transition-all overflow-hidden modal-shadow">
                <Dialog.Title
                  as="h3"
                  className="text-textMain text-style-h3 border-b border-gray10 pb-4 mx-8 overflow-hidden"
                >
                  Előfizetés lemondása
                </Dialog.Title>
                <button className='absolute top-9 right-6' onClick={onClose}>
                  <CancelIcon className='h-6 w-6 text-gray100 fill-current' />
                </button>

                <div id='content' className="flex flex-col gap-4 px-8 pt-6">
                  <p className="text-textMain text-style-body2">Előfizetésed lemondása esetén nem fogsz tudni hozzáférni bizonyos funkciókhoz.</p>
                  <div id="buttons" className='flex flex-col gap-4 pt-8'>
                    <CancelButton buttonInfo={{label: "Igen, lemondom"}} disabled={isActiveCancelButton} onClick={() => {cancelSubscription()}} />
                    <TertiaryButton buttonInfo={{label: "Mégsem"}} onClick={onClose} />
                  </div>
                </div>
              </Dialog.Panel>
            </Transition.Child>
          </div>
        </div>
      </Dialog>
    </Transition>
  );
}